module.exports = __webpack_public_path__ + "img/earth.bfeac6a7.svg";